/**
 * Hook for using dashboard master service with authentication
 * Provides access to dashboard master service with authentication tokens
 */

import { dashboardMasterService } from '../services/dashboardMasterService';

/**
 * Hook that provides access to the dashboard master service
 * Service now handles authentication internally via universalApiService
 */
export const useDashboardMasterAuth = () => {
  // Dashboard master service now handles tokens internally - no setup needed
  return dashboardMasterService;
};
